import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DetalleDescargaGrado3View from '../../components/listados/DetalleDescargaGrado3View'
import { obtenerDetalleMercaderiaGrado3 } from '../../actions/listados'

function DetalleDescargaGrado3 (props) {
  const { detalle, obtenerDetalleMercaderiaGrado3, fechaDesde, fechaHasta } = props

  useEffect(() => {
    obtenerDetalleMercaderiaGrado3(fechaDesde, fechaHasta, detalle.exportador, detalle.cereal, detalle.cerealVariedad)
  }, [obtenerDetalleMercaderiaGrado3, detalle, fechaDesde, fechaHasta])

  return (
    <DetalleDescargaGrado3View />
  )
}

const mapActionsToProps = {
  obtenerDetalleMercaderiaGrado3
}

const mapStateToProps = (state) => ({
  fechaDesde: state.stock.fechaDPorGrado,
  fechaHasta: state.stock.fechaHPorGrado
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleDescargaGrado3)
